var map = {
	"./MW_Telegram_Instruction_1.gif": "./src/assets/img/MW_Telegram_Instruction_1.gif",
	"./MW_Telegram_Instruction_2.gif": "./src/assets/img/MW_Telegram_Instruction_2.gif",
	"./MW_Telegram_Instruction_3.gif": "./src/assets/img/MW_Telegram_Instruction_3.gif",
	"./MW_Telegram_Instruction_4.gif": "./src/assets/img/MW_Telegram_Instruction_4.gif"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/img sync recursive ^\\.\\/MW_Telegram_Instruction_.*\\.gif$";